import { ArrowLeftRight, Building2, Link2, Upload } from 'lucide-react'

import { SubTabShell, type SubTab } from '@/components/SubTabShell'

const SUBTABS: SubTab[] = [
  { path: '/main',            label: '발주서 변환', Icon: Upload,    matchExact: true, hint: '발주서 파일 → 출고전표 자동 등록' },
  { path: '/main/code-match', label: '코드 매칭',   Icon: Link2,     hint: '발주서 코드 ↔ 품목 매핑 (견적코드로 연결)' },
  { path: '/main/dept-match', label: '부서 매칭',   Icon: Building2,  hint: '발주서 부서 ↔ 자식 거래처 라우팅' },
]

export function ConvertShell() {
  return (
    <SubTabShell
      Icon={ArrowLeftRight}
      title="발주서 변환"
      subtitle="발주서 파일 → 출고전표 자동 등록 · 상위 거래처로 자식 매출처 자동 라우팅"
      subtabs={SUBTABS}
    />
  )
}
